
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'

class SchedulingHelper {

    static getSchedulingPageStatusName(intl, status) {
        switch (status) {
            case 'draft':
                return intl.formatMessage({
                    id: "scheduling_page.status.draft_label",
                    defaultMessage: "Draft",
                })
            case 'active':
                return intl.formatMessage({
                    id: "scheduling_page.status.active_label",
                    defaultMessage: "Active",
                })
            case 'inactive':
                return intl.formatMessage({
                    id: "scheduling_page.status.inactive_label",
                    defaultMessage: "Inactive",
                })
            default: return ''
        }
    }

    static getCalendarEventStatusName(intl, status) {
        switch (status) {
            case 'confirmed':
                return intl.formatMessage({
                    id: "calendar_event.status.confirmed_label",
                    defaultMessage: "Confirmed",
                })
            case 'cancelled':
                return intl.formatMessage({
                    id: "calendar_event.status.cancelled_label",
                    defaultMessage: "Cancelled",
                })
            default: return ''
        }
    }

}

export default injectIntl(SchedulingHelper)


// WEBPACK FOOTER //
// ./src/scheduling-page/schedulinghelper.jsx